import { render, staticRenderFns } from "./InputTooltip.vue?vue&type=template&id=5faf47d6&"
import script from "./InputTooltip.vue?vue&type=script&lang=ts&"
export * from "./InputTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports